<template>
    <div class="w-full">
        <div
            class="swiper-container"
            :class="{ 'swiper-container-with-pagination': withPagination }"
        >
            <div class="swiper-wrapper">
                <slot></slot>
            </div>

            <!-- Add Arrows -->
            <button class="swiper-button-next" v-show="withArrows"></button>
            <button class="swiper-button-prev" v-show="withArrows"></button>

            <!-- Add Pagination -->
            <div v-if="withPagination" class="swiper-pagination"></div>
        </div>

        <div v-if="withThumbnails" class="swiper-thumbnails-container">
            <div class="swiper-wrapper">
                <slot name="thumbnails"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';

export default {
    provide() {
        return {
            parent: this.shared,
        };
    },

    props: {
        options: {
            default: () => {
                return {};
            },
            type: Object,
        },

        lazy: {
            default: false,
            required: false,
            type: Boolean,
        },

        withPagination: {
            default: false,
            type: Boolean,
        },

        withArrows: {
            default: false,
            type: Boolean,
        },

        withThumbnails: {
            default: false,
            type: Boolean,
        },

        thumbnailOptions: {
            default: () => {
                return {};
            },
            type: Object,
        },
    },

    data() {
        return {
            carousel: null,
            thumbnailCarousel: null,
            shared: {
                lazy: false,
            },
        };
    },

    methods: {
        defaultOptions() {
            let options = {};

            if (this.lazy) {
                this.shared.lazy = true;

                options.preloadImages = false;
                options.lazy = {
                    loadPrevNext: true,
                };
            }

            if (this.withPagination) {
                options.pagination = {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true,
                };
            }

            if (this.withArrows) {
                options.navigation = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                };
            }

            options.slidesPerView = 1;
            options.spaceBetween = 30;
            options.observer = true;

            return options;
        },

        defaultThumbnailOptions() {
            let options = {};

            options.slidesPerView = 7.5;
            options.spaceBetween = 10;
            options.observer = true;

            return options;
        },

        init() {
            if (this.options === undefined) {
                this.options = {};
            }

            if (this.thumbnailOptions === undefined) {
                this.thumbnailOptions = {};
            }

            let options = Object.assign(this.defaultOptions(), this.options);
            let thumbnailOptions = Object.assign(
                this.defaultThumbnailOptions(),
                this.thumbnailOptions
            );
            this.shared.options = options;

            if (this.withThumbnails) {
                this.thumbnailCarousel = new Swiper(
                    '.swiper-thumbnails-container',
                    thumbnailOptions
                );

                options.thumbs = { swiper: this.thumbnailCarousel };
            }

            this.carousel = new Swiper('.swiper-container', options);

            this.$events.listen('load-lazy-carousel', () => {
                setTimeout(() => {
                    this.carousel.lazy.load();
                }, 100);
            });
        },
    },

    mounted() {
        this.init();
    },
};
</script>
